<div class="p-2 position-relative">
    <div class="title p-2">
        <div class="d-flex justify-content-between align-items-center">
            <h4 class="mb-0 text-center">Istoric Subsemnat</h4>
            <div class="d-flex align-items-center">
                <button class="btn btn-small btn-info edit-btn" title="Descarcă" (click)="downloadChanges()">
                    <i class="fa fa-download fa-sm"></i>
                    Print
                </button>
            </div>
        </div>
    </div>

    <div class="container p-2">
        <table datatable [dtOptions]="dtOptions" class="row-border hover w-100"></table>
    </div>

    <div class="d-flex justify-content-between">
        <button class="buttons" type="button" mat-stroked-button (click)="closeDialog()">
            {{ helper.dialogConfig.buttonLabels.close }}
        </button>
    </div>

    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>